import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type TotalElementsType = number | null;

type CategoryStoreType = {
    categoryName: string;
    totalElements: TotalElementsType;
    setCategoryName: (categoryName: string) => void;
    setTotalElements: (totalElements: TotalElementsType) => void;
};

export const useCategoryStore = create<CategoryStoreType>()(
    immer((set) => ({
        categoryName: '',
        totalElements: null,

        setCategoryName: (categoryName) =>
            set((state) => {
                state.categoryName = categoryName;
            }),
        setTotalElements: (totalElements) =>
            set((state) => {
                state.totalElements = totalElements;
            })
    }))
);
